import React from 'react';
import ReactDOM from 'react-dom/client';
import { formatTime } from './utils/moment';
import ErrorBoundary from './components/error-boundary';
import App from './app';
import reportWebVitals from './reportWebVitals';
import config from './config';

import './index.css';
import './less/common.less';

import { initApp } from './init';

(async () => {
  try {
    await initApp();
  } catch (err) {
    console.warn('initApp error:', err);
  }

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    // <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
    // </React.StrictMode>
  );

  reportWebVitals();

  console.log(`当前版本：${config.version} 最后更新时间：${formatTime(config.updateTime)}`);
})();
